import Button from "@mui/material/Button";
import { SxProps, Theme } from "@mui/material/styles";
import { useStyles } from "./Common.styles";

interface LargeActionLinkProps {
	disabled?: boolean;
	className?: string;
	sx?: SxProps<Theme>;
	onClick: () => void;
	children: React.ReactNode;
}
export const LargeActionLink = ({ disabled, className, sx, onClick, children }: LargeActionLinkProps) => {
	const classes = useStyles();
	const cssClass = className ?? "";
	return (
		<Button className={`${classes.customLink} ${cssClass}`} onClick={onClick} disabled={disabled} sx={sx}>
			{children}
		</Button>
	);
};
